
import { showFormatedDate, base64Decode, alertConfirmation, DEMO, VIP, AIP, getAge } from './../../actions/utilAction';
import { Field, reduxForm } from 'redux-form';
import { getMasterData, getPatientProfileDetails, UpdateClientLockStatus, UpdatePatientActiveStatus, UpdatePatientPortalActivation, showPatientsSubMenus, UpdatePatientExcludeFullyPaidStatus } from './actions/PatientActions';
import { Tab, Tabs } from 'material-ui/Tabs';
import Alert from 'react-s-alert';
import { CommonButton } from '../../components/buttons';
import { connect } from 'react-redux';
import CustomFields from './custom_fields.js';
import FontIcon from 'material-ui/FontIcon';
import imageUrl from '../../img/profilebg.jpg';
import moment from 'moment';
import { NavLink } from 'react-router-dom';
import PatientProfileClientModal from './patient_profile_client_modal';
import { ProfileModal } from './components/common/displayProfile';
import React from 'react';
import { renderToggleButton, renderTextArea } from '../../components/reduxFields';
// import user1 from '../../img/noimage.png';
import JPG from '../../img/jpg.png';
import DOC from '../../img/doc.png';
import EXCEL from '../../img/excel.png';
import OTHER from '../../img/other.png';
import PDF from '../../img/pdf.png';
import PNG from '../../img/png.png';
import PPT from '../../img/ppt.png';
import TXT from '../../img/txt.png';

const style = {
  backgroundImage: 'url(' + imageUrl + ')',
  backgroundSize: 'cover',
  backgroundPosition: 'center center',
};

class PatientProfile extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      value: 0,
      slideIndex: null,
      patientId: props.match.params.id ? base64Decode(props.match.params.id) : null,
      encryptedPatientId: props.match.params.id ? props.match.params.id : null,
      firstName: '',
      patientAddressArray: [],
      patientPhoneArray: [],
      patientDiagnosisArray: [],
      middleName: '',
      lastName: '',
      profilePicture: '',
      profileFullPicture: '',
      baseAddress: '',
      patientObj: [],
      genderID: null,
      DOB: '',
      SSN: '',
      MRN: '',
      email: '',
      StaffName: '',
      city: '',
      countryID: '',
      zipCode: '',
      countryName: '',
      stateID: '',
      userID: null,
      userID1: null,
      stateName: '',
      phoneNumber: '',
      phoneType: '',
      includedData: [],
      master_data: [],
      appointmentDateArray: [],
      tagsArray: [],
      // diagnosisName: '-',
      vitalObj: null,
      realFeet: '',
      feet: '',
      inches: '',
      height: '',
      globalHeight: '',
      activeTab: 0,
      activeSubTab: 'address',
      openImage: false,
      masterTagsOriginal: [],
      activeToggleValue: false,
      lockToggleValue: false,
      lockToggleValue1: false,
      IsPortalActivated: false,
      open: false,
      uploadDocumentObj: null,
      patientDocs: [],
      IsPortalRequired: false,
      excludeFullyPaidToggleValue: false,
    };
    this.renderContactDetailsData = this.renderContactDetailsData.bind(this);
    this.UpdatePatientPortalActivation = this.UpdatePatientPortalActivation.bind(this);
    this.activeToggleStatus = this.activeToggleStatus.bind(this);
    this.lockToggleStatus = this.lockToggleStatus.bind(this);
    this.uploadDocumenthandler = this.uploadDocumenthandler.bind(this);
    this.handleCloseHandler = this.handleCloseHandler.bind(this);
  }

   componentWillMount() {
    //this.props.getPatientProfileDetails(this.state.patientId);        
    //this.props.documentUploadDownload(this.state.patientId);
    // this.props.getMasterData();
    // let searchObj = {
    //   filters: { TypeKey: 'ALL_CLIENT,BOTH' },
    // };
    // this.props.getMasterTags(searchObj);

    if (this.props.match.params.id !== undefined) {      
      this.setState({patientId : base64Decode(this.props.match.params.id), encryptedPatientId: this.props.match.params.id},()=>{
        this.props.showPatientsSubMenus(true);
        this.props.getPatientProfileDetails(this.state.patientId);
      });
    }
  }

  getLastAppointmentData() {
    let lastAppointment = null;
    let tempDate = new Date().setFullYear(new Date().getFullYear() - 50);
    this.state.appointmentDateArray.map((data, i) => {
      if (moment(data.attributes.StartDateTime) <= moment(new Date()) && moment(tempDate) <= moment(data.attributes.StartDateTime)) {
        tempDate = data.attributes.StartDateTime;
        lastAppointment = data.attributes;
      }
      return lastAppointment;
    });
    return lastAppointment;
  }

  getUpcomingAppointmentData() {
    let upcomingAppointment = null;
    let tempDate = new Date().setFullYear(new Date().getFullYear() + 50);
    this.state.appointmentDateArray.map((data, i) => {
      if (moment(data.attributes.StartDateTime) > moment(new Date()) && moment(tempDate) >= moment(data.attributes.StartDateTime)) {
        tempDate = data.attributes.StartDateTime;
        upcomingAppointment = data.attributes;
      }
      return upcomingAppointment;
    });
    return upcomingAppointment;
  }

  componentWillReceiveProps(nextProps) {
    // console.log('next props =>', base64Decode(nextProps.match.params.id),this.state.patientId);
    if (base64Decode(nextProps.match.params.id) !== this.state.patientId) {
      this.setState({ patientId: nextProps.match.params.id ? base64Decode(nextProps.match.params.id) : 0, encryptedPatientId: nextProps.match.params.id }, () => {
        this.props.getPatientProfileDetails(this.state.patientId);
        //this.props.documentUploadDownload(nextProps.match.params.id);
      });
    }

    if (nextProps.patientDocs && this.props.patientDocs !== nextProps.patientDocs) {
      this.setState({ patientDocs: nextProps.patientDocs });
    }

    if (nextProps.patientData && this.props.patientData !== nextProps.patientData) {
      let patientData = nextProps.patientData.data;
      // console.log('next props =>', nextProps.patientData);
      let patientDetails = patientData.patientInfo && patientData.patientInfo.length ? patientData.patientInfo[0] : {};
      this.setState({
        patientObj: patientDetails,
        IsPortalActivated: patientDetails.isPortalActivate,
        activeToggleValue: patientDetails.isActive,
        lockToggleValue: patientDetails.isBlock,
        lockToggleValue1: patientDetails.isBlock1,
        userID: patientDetails.userID,
        userID1: patientDetails.userID1,
        IsPortalRequired: patientDetails.isPortalRequired,
        excludeFullyPaidToggleValue: patientDetails.isExcludeFullyPaid,
      });
      this.setState({
        patientAddressArray: patientData.patientAddressesModel,
        patientPhoneArray: patientData.phoneNumberModel,
        patientDiagnosisArray: patientData.patientDiagnosisDetails,
        nextAppointmentArray: patientData.upcomingAppointmentDetails,
        lastAppointmentArray: patientData.lastAppointmentDetails,
        tagsArray: patientData.patientTagsModel,
      });

    }

    // if (nextProps.patientPrimaryDiagnosis && this.props.patientPrimaryDiagnosis !== nextProps.patientPrimaryDiagnosis) {
    //   // console.log(nextProps.patientPrimaryDiagnosis);
    //   let primaryDiagnosis = extractNameFromArray(nextProps.master_data.masterICD, nextProps.patientPrimaryDiagnosis.ICDID);
    //   this.setState({ diagnosisName: primaryDiagnosis ? primaryDiagnosis : '-',
    //     value: nextProps.patientPrimaryDiagnosis.IsActive === true ? 1 : 0 });
    // }

    if (nextProps.master_data && this.props.master_data !== nextProps.master_data) {
      this.setState({
        master_data: nextProps.master_data,
      });
    }

  }

  handleExcludeFullyPaidAlertClick = (event, patientId) => {
    this.setState({ excludeFullyPaidToggleValue: this.state.excludeFullyPaidToggleValue === true ? false : true }, () => this.props.UpdatePatientExcludeFullyPaidStatus(patientId, this.state.excludeFullyPaidToggleValue));
    Alert.closeAll();
  };
  excludeFullyPaidToggleStatus(e) {
    e.preventDefault();
    alertConfirmation('Are you sure you want to change status of client?', {
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleExcludeFullyPaidAlertClick,
        id: this.state.patientId,
      },
    });
  }

  handleActiveAlertClick = (event, patientId) => {
    this.setState({ activeToggleValue: this.state.activeToggleValue === true ? false : true }, () => this.props.UpdatePatientActiveStatus(patientId, this.state.activeToggleValue));
    Alert.closeAll();
  };
  activeToggleStatus(e) {
    e.preventDefault();
    alertConfirmation('Are you sure you want to change active/inactive status of client?', {
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleActiveAlertClick,
        id: this.state.patientId,
      },
    });
  }
  handleLockAlertClick = (event, userID) => {
    this.setState({ lockToggleValue: this.state.lockToggleValue === true ? false : true }, () => this.props.UpdateClientLockStatus(userID, this.state.lockToggleValue, this.state.patientId));
    Alert.closeAll();
  };
  lockToggleStatus(e) {
    e.preventDefault();
    alertConfirmation('Are you sure you want change the client\'s lock status ?', {
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleLockAlertClick,
        id: this.state.userID,
      },
    });
  }

  handleLockAlertClick1 = (event, userID) => {
    this.setState({ lockToggleValue1: this.state.lockToggleValue1 === true ? false : true }, () => this.props.UpdateClientLockStatus(userID, this.state.lockToggleValue1, this.state.patientId));
    Alert.closeAll();
  };
  lockToggleStatus1(e) {
    e.preventDefault();
    alertConfirmation('Are you sure you want change the client\'s lock status ?', {
      customFields: {
        displayComponent: true,
        handleButtonClick: this.handleLockAlertClick1,
        id: this.state.userID1
      },
    });
  }

  UpdatePatientPortalActivation() {
    Alert.closeAll();
    this.setState({ IsPortalActivated: !this.state.IsPortalActivated }, () => this.props.UpdatePatientPortalActivation(this.state.patientId, this.state.userID, this.state.IsPortalActivated));
  }

  
  renderContactDetailsData() {
    // console.log('this.state.patientAddressArray...............',this.state.patientAddressArray)
    return (<div>
      <div className="clearfix"></div>
      {this.state.activeSubTab === 'address' ?
        <div>
          <div className="pateint-page-contact client_detail">
            {!this.state.patientAddressArray.length ?
              '' : this.state.patientAddressArray.map((AddressDetail, index) => {
                let { address1, apartmentNumber, city, stateName, countryName, zip, addressType, others } = AddressDetail;


                // console.log('AddressDetail....', AddressDetail);
                return (
                  <div key={index} >
                    <address>
                      <h3>
                        {addressType === 'Other' ? `${addressType} (${others})` : addressType}</h3>
                      <ul>
                        <li>Address - <span>{address1 + (apartmentNumber ?  ' ' + apartmentNumber : '')}</span></li>
                        <li>City - <span>{city}</span></li>
                        <li>State - <span>{stateName}</span></li>
                        <li>Zip - <span>{zip}</span></li>
                        <li>Country - <span>{countryName}</span></li>
                        {/* <li>8400 London Place, Washington, DC 20521-8400</li>*/}
                      </ul>
                    </address>
                  </div>);
              })
            }
          </div>

        </div> :
        <div>

          <div className="pateint-page-contact">
            {!this.state.patientPhoneArray.length ?
              '' : this.state.patientPhoneArray.map((phoneDetail, index) => {
                let phoneNumber = phoneDetail.phoneNumber;
                let phoneType = phoneDetail.phoneNumberType;
                let preference = phoneDetail.preference;
                let otherPhoneNumberType = phoneDetail.otherPhoneNumberType;
                return (
                  <div key={index}>
                    <address>
                      <h3>{otherPhoneNumberType ? `${otherPhoneNumberType} (${phoneType})` : (phoneType || '') }:</h3>
                      <ul>
                        <li>Phone: {phoneNumber || '-'}</li>
                        <li>Preference: {preference || '-'}</li>
                      </ul>
                    </address>
                  </div>);
              })
            }
          </div>

        </div>}
    </div>);
  }

  renderDownloadDocs() {
    // console.log(this.state.patientDocs);
    let extension;
    if (this.state.patientDocs && this.state.patientDocs.length) {
      return this.state.patientDocs.map((obj, index) => {
        extension = obj.url.split('.').pop();

        if (extension === 'jpg' || extension === 'jpeg') {
          return (
            <a key={index} href={`${obj.url}`} download>
              <img src={JPG} width="50" height="50" title={obj.url} />
            </a>
          );
        } else if (extension === 'png') {
          return (
            <a key={index} href={`${obj.url}`} download>
              <img src={PNG} width="50" height="50" alt="text" title={obj.url} />
            </a>
          );
        } else if (extension === 'txt') {
          return (
            <a key={index} href={`${obj.url}`} download>
              <img src={TXT} width="50" height="50" alt="text" title={obj.url} />
            </a>
          );
        } else if (extension === 'docx' || extension === 'doc') {
          return (
            <a key={index} href={`${obj.url}`} download>
              <img src={DOC} width="50" height="50" alt="text" title={obj.url}/>
            </a>
          );
        } else if (extension === 'xlsx') {
          return (
            <a key={index} href={`${obj.url}`} download>
              <img src={EXCEL} width="50" height="50" alt="text" title={obj.url}/>
            </a>
          );
        } else if (extension === 'pdf') {
          return (
            <a key={index} href={`${obj.url}`} download>
              <img src={PDF} width="50" height="50" alt="text" title={obj.url}/>
            </a>
          );
        } else if (extension === 'ppt') {
          return (
            <a key={index} href={`${obj.url}`} download>
              <img src={PPT} width="50" height="50" alt="text" title={obj.url} />
            </a>
          );
        } else if (extension) {
          return (
            <a key={index} href={`${obj.url}`} download>
              <img src={OTHER} width="50" height="50" alt="text" title={obj.url}/>
            </a>
          );
        } else {
          return (<a key={index}></a>);
        }
      });
    }
  }

  renderTags() {
    if (this.state.tagsArray.length === 0) {
      return (
        <ul className="tags">
          <li className="tag">No tags found.</li>
        </ul>
      );
    }
    return (<ul className="tags">
      {
        this.state.tagsArray.map((tag, index) => {
          let tagName = tag.tag
            , tagColor = tag.colorCode
            , tagFontColor = tag.fontColorCode;

          if (tagName) {
            return <li key={index}><span className="tagafter" style={{ backgroundColor: tagColor }}></span><span className="tag" style={{ backgroundColor: tagColor, color: tagFontColor }}>{tagName}</span></li>;
          }
          return { tagName, tagColor, tagFontColor };
        })
      }
    </ul>);
  }

  renderLastOrUpcommingAppointment(lastAppointment, upcomingAppointment) {
    let appointmentData = null;
    lastAppointment ?
      appointmentData = this.state.lastAppointmentArray && this.state.lastAppointmentArray.length ? this.state.lastAppointmentArray[0] : null
      : appointmentData = this.state.nextAppointmentArray && this.state.nextAppointmentArray.length ? this.state.nextAppointmentArray[0] : null;
    // console.log('nextAppointmentArray............', this.state.nextAppointmentArray)
    if (!appointmentData) {
      return (
        <div className="col-sm-6 col-6 lastdr">
          <h3>{lastAppointment ? 'Last' : 'Upcoming'} Appointment</h3>
          <div>No appointment found.</div>
        </div>
      );
    }
    return (
      <div className="col-sm-6 col-6 lastdr">
        <h3>{lastAppointment ? 'Last' : 'Upcoming'} Appointment</h3>
        <div className="latestdoctor">
          <img src={appointmentData.staffImageUrl || require('../../img/doctor.png')} alt="" />
        </div>
        <div className="latestcontent">
          <ul>
            <li>{''}</li>
            {/* //<li>MBBS</li> */}
            <li>Staff Name : {lastAppointment ? appointmentData.lastAppointmentStaff : appointmentData.upcomingAppointmentStaff || '-'}</li>
            <li>{lastAppointment ? showFormatedDate(appointmentData.lastAppointment) : showFormatedDate(appointmentData.upcomingAppointment)}</li>
            {/* <li>Co-Pay: <span><i className="fa fa-usd" aria-hidden="true"></i> 00.00</span></li> */}
          </ul>
        </div>
      </div>
    );
  }

  setActive(tabValue) {
    this.setState({ activeTab: tabValue });
  }

  handleOpen = () => {
    this.setState({ openImage: true });
  };

  uploadDocumenthandler = () => {
    this.setState({ open: true, uploadDocumentObj: null });
    // console.log('inside uploadDocumentHandler');
  }

  handleClose = () => {
    this.setState({ openImage: false });
  };

  handleCloseHandler = () => {
    if (this.state.open) {
      //  this.props.clearFieldErrorArray();
      this.setState({ open: false });
      //  this.props.closeDialog();
    }
  }

  activeHandler = (clickedLI) => {
    this.setState({ activeSubTab: clickedLI });
  };

  renderEmergencyContacts = () => {
    if(this.props.patientData !== undefined && this.props.patientData !== null) {
      let patientInfo = this.props.patientData.data.patientInfo[0]
      return (
        <div className="client_detail text-left" style={{ color: '#7a7a7a',fontWeight: '300', fontSize: '15px'}}>
          <div><b>Name :&nbsp;</b><span>{patientInfo.emergencyContactFirstName}&nbsp;{patientInfo.emergencyContactLastName}</span></div>
          <div><b>Phone :&nbsp;</b><span>{patientInfo.emergencyContactPhone}</span></div>
          <div><b>Relationship :&nbsp;</b><span>{patientInfo.emergencyContactRelationship}</span></div>
        </div>
      )
    } else {
      return;
    }
  }

  renderGuardianContacts = () => {
    if (this.props.patientData !== undefined && this.props.patientData !== null) {
      let patientGuardians = this.props.patientData.data.patientGuardian;
      return (
        <div className="row mt-15">
          {patientGuardians && patientGuardians.length > 0 ? patientGuardians.map((data, index) => (
            <div className="col-sm-4 mb-4" key={index}>
              <div className="client_detail text-left" style={{ color: '#7a7a7a', fontWeight: '300', fontSize: '15px' }}>
                <div><b>Name :&nbsp;</b><span>{data.guardianFirstName}&nbsp;{data.guardianLastName}{data.isGuarantor === true ? <span>&nbsp;(Guarantor)</span> : ''}</span></div>
                <div><b>Phone :&nbsp;</b><span>{data.guardianHomePhone}</span></div>
                <div><b>Relationship :&nbsp;</b><span>{data.relationshipName}</span></div>
               {data.guardianEmail ?<div><b>Email: &nbsp;</b><span>{data.guardianEmail}</span></div> : ""} 
              </div>
            </div>
          )) : null}
        </div>
      );
    }
  }
  
  

  render() {
    var styles = {
      activeStyle: {
        color: 'green',
      },
      labelStyle: {
        color: ' #7a7a7a',
        fontWeight: 400,
      },
      inActiveStyle: {
        color: 'red',
      },
      default_tab: {
        height: '50px',
        fontSize: '13px',
      },
      active_tab: {
        color: '#fff',
        backgroundColor: 'rgba(0, 0, 0, 0.10)',
        height: '48px',
        fontSize: '13px',
      },
    };
    styles.tab = [];
    styles.tab[0] = styles.default_tab;
    styles.tab[1] = styles.default_tab;
    styles.tab[2] = styles.default_tab;
    styles.tab[3] = styles.default_tab;
    styles.tab[4] = styles.default_tab;
    styles.tab[5] = styles.default_tab;
    styles.tab[this.state.activeTab] = styles.active_tab;
    styles.tab[this.state.slideIndex] = Object.assign({}, styles.tab[this.state.slideIndex], styles.active_tab);
    let { photoPath
      , photoThumbnailPath
      , name
      , gender
      , dob
      , ssn
      , mrn
      , email
      , note
      , primaryInsuranceNames
      , assignedStaff
    } = this.state.patientObj;
    let phoneDetail = this.state.patientPhoneArray && this.state.patientPhoneArray.length ? this.state.patientPhoneArray[0] : null;
    let AddressDetail = this.state.patientAddressArray && this.state.patientAddressArray.length ? this.state.patientAddressArray.find((obj, index) => obj.addressType.toUpperCase() === 'PRIMARY HOME') : null;
    //let diagnosisDetail = this.state.patientDiagnosisArray && this.state.patientDiagnosisArray.length ? this.state.patientDiagnosisArray : null;
    let PhoneNumber = ''
      , fullAddress = '-'
      , phoneType = ''
      , ssnLast4Digits = ssn ? ssn.substr(ssn.length - 4) : ''
      //, mrnLast4Digits = mrn ? mrn.substr(mrn.length - 4) : ''
      , mrnNumber = mrn ? mrn : ''
      , fullName = name
      //, diagnosisName = '';
      , primaryInsurance = primaryInsuranceNames ? primaryInsuranceNames.trim() : ''
    if (phoneDetail) {
      PhoneNumber = phoneDetail.phoneNumber;
      phoneType = phoneDetail.phoneNumberType;
    }
    if (AddressDetail) {
      let { address1, apartmentNumber, city, stateName, countryName, zip } = AddressDetail;
      fullAddress = `${address1 +  (apartmentNumber ?  ' ' + apartmentNumber : '')}, ${city}, ${stateName}, ${countryName}, ${zip}`;
    }
    // if (diagnosisDetail) {
    //   let diagnosis = diagnosisDetail.find((obj) => obj.isPrimary);
    //   if (diagnosis) {
    //     diagnosisName = `${diagnosis.code} ${diagnosis.description}`;
    //   }
    // }
    return (
      <div className="profilepage">
        {this.state.openImage ?
          <ProfileModal openImage={this.state.openImage} closeDialog={this.handleClose} profileFullPicture={photoPath} />
          : ''}
        {
          this.state.open ? <PatientProfileClientModal closeDialog={this.handleCloseHandler} /> : ''
        }
        <h2 className="page_title">Profile Summary</h2>
        <div className="btn_rt top_btn">
         {this.state.IsPortalRequired && this.props.activatePortalPermission ?
            this.state.IsPortalActivated ?
              <CommonButton onTouchTap={(e) => this.UpdatePatientPortalActivation(e)} type="button" label='Deactivate Portal' className="smbtn activeport disable-btn" primary={true} />
              :
              <CommonButton onTouchTap={(e) => this.UpdatePatientPortalActivation(e)} type="button" label='Activate Portal' className="smbtn activeport " primary={true} />
            : null
          }
          <NavLink
            key={this.state.encryptedPatientId}
            to={`/client/${this.state.encryptedPatientId}`}>
            {this.props.updatePermission ?
              <CommonButton className="smbtn editclient" primary={true} label="Edit" />
              : null
            }
          </NavLink>
        </div>

        <div className="clearfix"></div>
        <div className="row">
          <div className="col-sm-5">
            <div className="readmin-panel crop">
              <div className="panel-body pd15">
                <div className="profilebg" style={style}>
                  <div className="clientpic">
                    {photoThumbnailPath ? <img src={photoThumbnailPath} alt="" onClick={this.handleOpen} /> : name ? (name.split(' ').length > 1 ? <span className="userletter">{name.split(' ')[0][0].toUpperCase() + name.split(' ')[name.split(' ').length - 1][0].toUpperCase()}</span> : <span className="userletter">{name[0].toUpperCase()}</span>) : ''}
                  </div>
                </div>
                <h2 className="ppname">{fullName || ''}</h2>
                <div className="ppdetail client_detail">
                  <div className="ledtdiv">
                    <p><b>Gender : </b><span>{gender || '-'}</span></p>
                    <p><b>D.O.B :</b> <span>{dob ? showFormatedDate(dob) : '-'}</span> <span>({dob ? getAge(showFormatedDate(dob)) : ''})</span></p>
                    <p><b>SSN :</b> <span>{ssnLast4Digits ? '***-**-' + ssnLast4Digits : '-'}</span></p>
                    {/* <p><b>Client ID :</b> <span>{mrnLast4Digits ? '*****' + mrnLast4Digits : '-'}<i aria-hidden="true"></i></span></p> */}
                    {mrnNumber ? <p><b>Client ID :</b> <span>{mrnNumber ? mrnNumber : '-'}<i aria-hidden="true"></i></span></p>: null}                    
                  </div>
                  {primaryInsurance ? <p><b>Primary Payer(s) :</b> <span>{primaryInsurance ? primaryInsurance : '-'}<i aria-hidden="true"></i></span></p>: null}
                  {/* <p><b>Diagnosis : </b><span>{diagnosisName}</span></p> */}
                  <p>
                    {this.props.changeActiveStatusPermission ?
                      <Field
                        name="status"
                        label="Active"
                        className='no_margin'
                        toggled={this.state.activeToggleValue}
                        component={renderToggleButton}
                        onChange={(e) => this.activeToggleStatus(e)}
                      />
                      : null
                    }
                  </p>
                  <p>
                    {this.props.changeLockStatusPermission ?
                      <Field
                        name="lock"
                        label="Lock Account 1"
                        className='no_margin'
                        toggled={this.state.lockToggleValue}
                        component={renderToggleButton}
                        onChange={(e) => this.lockToggleStatus(e)}
                      />
                      : null
                    }
                  </p>
                  <p>
                    {(this.props.agencyName.toUpperCase() === 'DEMO' || this.props.agencyName.toUpperCase() === VIP || this.props.agencyName.toUpperCase() === AIP) && this.props.changeLockStatusPermission &&  this.state.userID1 != null ?
                      <Field
                        name="lock"
                        label="Lock Account 2"
                        className='no_margin'
                        toggled={this.state.lockToggleValue1}
                        component={renderToggleButton}
                        onChange={(e) => this.lockToggleStatus1(e)}
                      />
                      : null
                    }
                  </p>
                  <p>
                    {this.props.changeActiveStatusPermission ?
                      <Field
                        name="status"
                        label="Exclude From Client Invoice Report"
                        className='no_margin'
                        toggled={this.state.excludeFullyPaidToggleValue}
                        component={renderToggleButton}
                        onChange={(e) => this.excludeFullyPaidToggleStatus(e)}
                      />
                      : null
                    }
                  </p>
                  
                </div>
                <div className="clearfix"></div>
                <address>
                  <div className="client_detail text-left">
                    <p><b>Phone : </b><span>{PhoneNumber ? `${PhoneNumber} (${phoneType})` : '-'}</span></p>                    
                    {email ?
                      <p><b>Email : </b><span>{email || '-'}</span></p>
                      : null}
                    <p><b>Address : </b><span>{fullAddress}</span></p>
                  </div>
                </address>
              </div>
            </div>
          </div>
          <div className="col-sm-7">
            <div className="row">
              <div className="col-sm-12">
                <div className="readmin-panel">
                  <div className="panel-body pd15">
                    <div className="lineheader">
                      <p>Tags</p>
                    </div>
                    <div className="quicksubmenu tagbox mhgt80">
                      {this.renderTags()}
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-sm-12 mt-30">
                <div className="readmin-panel crop appoint">
                  <div className="panel-body pd15">
                    <div className="lineheader">
                      <p><NavLink to={`/client/scheduling/${this.state.encryptedPatientId}`} exact >Appointments Details</NavLink></p>
                    </div>
                    <div className="row">
                      {this.renderLastOrUpcommingAppointment(false)}
                      {this.renderLastOrUpcommingAppointment(true)}
                    </div>
                  </div>
                </div>
              </div>

              <div className="col-sm-12 mt-30">
                <div className="readmin-panel crop appoint">
                  <div className="panel-body pd15">
                    <div className="lineheader">
                      <p>Emergency Contacts</p>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        {this.renderEmergencyContacts()}
                    
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              {assignedStaff && <div className="col-sm-12 mt-30">
                <div className="readmin-panel crop appoint">
                  <div className="panel-body pd15">
                    <div className="lineheader">
                      <p>Assigned Staff(s)</p>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        {assignedStaff}
                    
                      </div>
                    </div>
                  </div>
                </div>
              </div>}
            </div>
          </div>
          <div className="col-sm-12 mt-30">
                <div className="readmin-panel crop appoint">
                  <div className="panel-body pd15">
                    <div className="lineheader">
                      <p>Other Contacts</p>
                    </div>
                    <div className="row">
                      <div className="col-sm-12">
                        {this.renderGuardianContacts()}
                    
                      </div>
                    </div>
                  </div>
                </div>
              </div>
          <div className="col-sm-12  mt-30">
            <div className="readmin-panel crop appoint">
              <div className="panel-body pd15">
                <Tabs className="tabbox">
                  <Tab className="customtab" style={styles.tab[0]} onClick={(e) => this.setActive(0)} value="0" icon={<FontIcon className="material-icons">local_library</FontIcon>} label={<font>Contact Details</font>}>
                    <div className="custom_form">
                      <ul className="tabs-sm address_detail">
                        <li id="address"
                          onClick={() => this.activeHandler('address')}
                          className={this.state.activeSubTab === 'address' ? 'active' : ''}>
                          <a href="#address"><i className="flaticon flaticon-placeholder"></i>Addresses</a>
                        </li>
                        <li id="phone"
                          onClick={() => this.activeHandler('phones')}
                          className={this.state.activeSubTab === 'phones' ? 'active' : ''}>
                          <a href="#phone"><i className="flaticon flaticon-agenda"></i>Phone Numbers</a>
                        </li>
                      </ul>

                      {this.renderContactDetailsData()}

                    </div>
                  </Tab>
                  <Tab className="customtab" style={styles.tab[1]} onClick={(e) => this.setActive(1)} value="1" icon={
                    <FontIcon className="material-icons">build</FontIcon>
                  } label={<font>Custom Fields</font>} >
                    <div className="col-sm-12" style={{ fontWeight: 'bold' }}>
                      <CustomFields isPatientProfilePage={true} patientId={this.state.patientId} />
                    </div>
                  </Tab>
                  <Tab className="customtab" style={styles.tab[2]} onClick={(e) => this.setActive(2)} value="2" icon={
                    <FontIcon className="material-icons">assignment</FontIcon>
                  } label={<font>Notes</font>} >
                    <form className="readmin-form custom_form">
                        {note ? 
                         <div className="col-sm-12">
                            <Field
                              name="note"
                              type="text"
                              fullWidth={true}
                              //label="Assessment"
                              // autoHeight={true}
                              disabled={true}                      
                              component={renderTextArea}
                          />
                          </div>
                          : 
                          <div className="col-sm-12 mt-40">
                            <span> {note || 'No notes available'} </span>
                          </div>}                                       
                    </form>
                  </Tab>
                  {/* <Tab
                    className="customtab"
                    style={styles.tab[2]}
                    onClick={(e) => this.setActive(3)} value="3"
                    label={<font>Upload</font>}
                    icon={
                      <FontIcon className="material-icons">file_upload</FontIcon>
                    }>
                    <div className="col-sm-12 mt-40">
                      <span>
                        <CommonButton label="Upload Document" primary={true} onTouchTap={this.uploadDocumenthandler} />
                        <p style={{ marginTop: '5px' }}>
                          {this.renderDownloadDocs()}
                        </p>
                      </span>
                    </div>
                  </Tab> */}
                </Tabs>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
PatientProfile = reduxForm({
  form: 'PatientProfileForm',
  enableReinitialize: true,
})(PatientProfile);

function mapStateToProps(state) {
  // Start For Role Permission
  let userActionPermission = [];
  if (state.login.userPermission) {
    let userModulePermission = state.login.userPermission.modulePermissions.filter((obj) => obj.moduleKey === 'CLIENT');
    let userScreenPermission = state.login.userPermission.screenPermissions.filter((obj) => obj.screenKey === 'CLIENT_PROFILE' && obj.moduleId === userModulePermission[0].moduleId);
    userActionPermission = state.login.userPermission.actionPermissions.filter((obj) => obj.screenId === userScreenPermission[0].screenId && obj.moduleId === userModulePermission[0].moduleId && obj.roleId === state.login.loginUserInfo.roleID);
  }

  let hasDefaultAccess = state.login.loginUserInfo && state.login.loginUserInfo.users3.userRoles.userType === 'ADMIN' ? true : false; // For Role Permission

  let activatePortalPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'CLIENT_PROFILE_PORTAL')[0].permission : false;
  let updatePermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'CLIENT_PROFILE_UPDATE')[0].permission : false;
  let changeActiveStatusPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'CLIENT_INSURANCE_CHANGESTATUS')[0].permission : false;
  let changeLockStatusPermission = hasDefaultAccess ? true : userActionPermission ? userActionPermission.filter((obj) => obj.actionKey === 'CLIENT_INSURANCE_CHANGELOCK')[0].permission : false;


  // End For Role Permission
  let initialData = {};
  initialData['note'] = state.patient.patientProfileDetails && state.patient.patientProfileDetails.data && state.patient.patientProfileDetails.data.patientInfo && state.patient.patientProfileDetails.data.patientInfo.length > 0  ? state.patient.patientProfileDetails.data.patientInfo[0].note : 'No notes available';
  return {
    initialValues: initialData,
    patientData: state.patient.patientProfileDetails,
    activatePortalPermission: activatePortalPermission, // For Role Permission
    updatePermission: updatePermission, // For Role Permission
    changeActiveStatusPermission: changeActiveStatusPermission, // For Role Permission
    changeLockStatusPermission: changeLockStatusPermission, // For Role Permission
    patientDocs: state.patient.patientDocumentDownload,
    agencyName: state.login.organizationDetails && state.login.organizationDetails.businessName ? state.login.organizationDetails.businessName : '',
  };
}
PatientProfile = reduxForm({
  form: 'PatientProfileForm',
})(PatientProfile);
export default connect(mapStateToProps, { getMasterData, getPatientProfileDetails, UpdatePatientActiveStatus, UpdateClientLockStatus, UpdatePatientPortalActivation, showPatientsSubMenus, UpdatePatientExcludeFullyPaidStatus })(PatientProfile);



// WEBPACK FOOTER //
// ./src/modules/patients/patient_profile_client.js